import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAward, faClock, faUsers, faIndustry } from "@fortawesome/free-solid-svg-icons";

const stats = [
  { icon: faAward, value: "25+", label: "Years Experience" },
  { icon: faUsers, value: "500+", label: "Happy Clients" },
  { icon: faIndustry, value: "6", label: "Industries Served" },
  { icon: faClock, value: "24/7", label: "Support" },
];

const Intro = () => {
  return (
    <Container fluid className="intro-section">
      <Container>
        <Row className="intro-content align-items-center">
          <Col lg={5} className="intro-title-col">
            <span className="intro-label">Who We Are</span>
            <h2 className="intro-title">A Shining Legacy</h2>
          </Col>
          <Col lg={7} className="intro-text-col">
            <p className="intro-description">
              We're the go-to electroplating company, thriving on expert
              techniques and top-notch quality to transform products and breathe
              new life into old items. Let us show you the true meaning of
              brilliance!
            </p>
          </Col>
        </Row>
        <Row className="stats-row">
          {stats.map((stat, index) => (
            <Col xs={6} md={3} key={index} className="stat-item">
              <div className="stat-icon-wrapper">
                <FontAwesomeIcon icon={stat.icon} className="stat-icon" />
              </div>
              <span className="stat-value">{stat.value}</span>
              <span className="stat-label">{stat.label}</span>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
};

export default Intro;
